import { render } from "./App.vue?vue&type=template&id=8ccfe20e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8ccfe20e&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__